import { useQuery, useQueryClient } from 'react-query';
import MfaDevice from 'services/data/mfa-device';
import MfaConnectionLog from 'services/data/mfa-connection-log';

export function useMfaDevice(id, queryOptions = {}) {
  const key = ['mfadevice', id];

  const queryClient = useQueryClient();
  const queryData = useQuery(
    key,
    () => MfaDevice.findOne(id),
    { enabled: !!id, ...queryOptions }
  );

  return { ...queryData, refetch: () => queryClient.refetchQueries(key) };
}

export function useMfaConnectionLog(deviceId, queryOptions = {}) {
  const key = ['mfaconnectionlog', deviceId];

  const queryClient = useQueryClient();
  const queryData = useQuery(
    key,
    () => MfaConnectionLog.find({
      where: { mfaDevice: deviceId },
      sort: 'connectedAt DESC',
      load: ['person', 'person.team'],
      limit: 50
    }),
    { enabled: !!deviceId, ...queryOptions }
  );

  return { ...queryData, refetch: () => queryClient.refetchQueries(key) };
}
